export default __webpack_public_path__ + "favicon-16x16.v2.6a337f3e22e2bac325dc3a908ee02684.svg";